function dragstart(ev) {
	let randomClass = "randomClassForTransfer" + (2**53) * Math.random()
	ev.target.classList.add(randomClass)
	ev.dataTransfer.setData("randomClass", randomClass);
}

module.exports = {dragstart}
